// extracted by mini-css-extract-plugin
export default {"title":"title--deoq1","subtitle":"subtitle--iNxVW","logout-buttons":"logout-buttons--Kj51o","logoutButtons":"logout-buttons--Kj51o"};